import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../utils/axios";

const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchItemAuditDataApi = createAsyncThunk(
  "itemData/fetchItemAuditDataApi",
  async ({ id }) => {
    const response = await axiosInstance.request({
      url: `audit?ip_id=${id}`,
      method: "GET",
    });
    return response;
  }
);

const itemAuditDataSlice = createSlice({
  name: "itemAuditData",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchItemAuditDataApi.pending, (state) => {
        state.loading = true;
        state.data = [];
      })
      .addCase(fetchItemAuditDataApi.fulfilled, (state, action) => {
        state.completed = true;
        state.data = action.payload.data;
        state.loading = false;
      })
      .addCase(fetchItemAuditDataApi.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const itemAuditDataReducer = itemAuditDataSlice.reducer;

export default itemAuditDataReducer;

export const itemAuditDataActions = itemAuditDataSlice.actions;
